import AccessResponse from "admin/types/interfaces/access";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

const useGroupAccess = (groupName: string) => {
  return useFetcher<AccessResponse>(`${VITE_ACCESS_CONTROLLER_API}/user-tags/${groupName}/access`);
};

export default useGroupAccess;
